import React from "react";
import * as ReactDOM from "react-dom/client";
window.React = React;

import "./vendor/ds_bundle.js";

const DS = window.FrameriverDesignSystem_039b66;
export const { Button, Badge, Tag, Card, StatusPill, Progress, Avatar } = DS;
